@import '../../../constants/spacing.module.less';

@terms-max-width: 612px;
@terms-width: 100%;

.text-link {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.ddp-terms-modal {
  max-width: 644px;
  width: 90vw;
  max-height: 90vh;
  height: auto;

  .modal-header h3,
  .modal-title,
  h3 {
    color: var(--gray-45505B);
    font-size: 16px;
  }

  .modal-footer {
    background: var(--gray-F9FAFB);
  }
}

.modal-body {
  padding: @space-24;
  display: flex;
  flex-direction: column;
  min-height: 260px;
}

.modal-content {
  flex-direction: column;
  flex: 1;
  gap: @space-8;

  .modal-footer,
  .modal-actions,
  .modal-buttons,
  .actions,
  .buttons {
    background: var(--gray-F9FAFB);
  }
}

.main-text {
  color: var(--grey-700);
  line-height: 1.5;
  margin-bottom: @space-16;
}

.checkbox-section {
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  width: @terms-width;
  max-width: @terms-max-width;
  margin-bottom: @space-8;
}

.terms-checkbox {
  width: @terms-width;

  .label-text {
    max-width: @terms-max-width;
  }
}

.link-section {
  margin-left: @space-24;
}

.terms-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--blue-006FBB);
  flex: none;
  order: 1;
  flex-grow: 0;
  gap: @space-4;

  &:hover {
    color: var(--blue-006FBB);
  }

  &:focus {
    outline: 2px solid var(--blue--300);
    outline-offset: 2px;
  }
}

.terms-link-text {
  .text-link();
  text-decoration-line: underline;
  color: var(--blue-006FBB);

  .terms-link:hover & {
    color: var(--blue-006FBB);
  }
}

.external-link-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.carrier-info {
  color: var(--grey-600);
  font-style: italic;
  margin-bottom: @space-8;
}

.error-text {
  color: var(--red-D73502);
  font-weight: 500;
  margin-top: @space-8;
}
